
import { Answer } from "@/data/questions";
import { computed, defineComponent } from "vue";
import { returnQuestionStat } from "@/helpers/index";

export default defineComponent({
  name: "ResultsCard",
  props: {
    answer: {
      type: Answer,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isCommunity: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const stat = computed(() =>
      returnQuestionStat(props.answer.key, props.index)
    );

    const resultText = computed(() => {
      return props.isCommunity
        ? props.answer.communityCityText
        : props.answer.yourCityText;
    });

    const total = computed(() => returnQuestionStat("total", props.index));

    const getSubtitle = (
      num: number,
      categoryText: string,
      total: number
    ): string => {
      const percent = Math.round((num / total) * 100);
      const rand = Math.floor(Math.random() * 3);

      if (props.isCommunity) {
        return `${percent}% of all Mytopia cities chose ${categoryText.toLowerCase()}`;
      }

      switch (rand) {
        case 0:
          return `'${categoryText}' was chosen ${num} other times`;
        case 1:
          return `${num} other Mytopia cities also chose ${categoryText.toLowerCase()}`;
        case 2:
          return `${percent}% of all Mytopia cities chose ${categoryText.toLowerCase()}`;
        default:
          return `'${categoryText}'' was chosen ${num} other times`;
      }
    };
    return { getSubtitle, stat, total, resultText };
  },
});
